/**
 * Канонические path-сегменты для `frontend/embed` (латиница).
 * Полная таблица: .cursor/rules/frontend-embed-path-slugs.mdc
 */
/** Карточка занятия / слота */
export function pathSession(slotId: number | string): string {
  return `/sessions/${slotId}`;
}

export function pathTrainer(trainerId: number | string): string {
  return `/trainers/${trainerId}`;
}

export function pathService(serviceId: number | string): string {
  return `/services/${serviceId}`;
}

export const PATH = {
  home: '/',
  signIn: '/sign-in',
  register: '/register',
  forgotPassword: '/forgot-password',
  resetPassword: '/reset-password',
  /** Онбординг: ПДн, CRM, профиль, соглашение организации */
  agreements: '/agreements',
  /** Подтверждение email (блокирующий гейт до подтверждения) */
  confirmEmail: '/confirm-email',
  /** Тренерский контур (staff JWT) */
  trainer: '/trainer',
  trainerSignIn: '/trainer/sign-in',
  trainerSelectBranch: '/trainer/select-branch',
  /** Суперадмин: выбор студии, в которой работает. */
  trainerSelectStudio: '/trainer/select-studio',
  trainerProfile: '/trainer/profile',
  trainerWorkSchedule: '/trainer/work-schedule',
  trainerMySessions: '/trainer/my-sessions',
  trainerBookClient: '/trainer/book-client',
  organizations: '/organizations',
  branches: '/branches',
  schedule: '/schedule',
  catalog: '/catalog',
  appHub: '/app',
  /** domcrm-core fitness (см. EMBED_FITNESS в shared/api/fitness) */
  fitness: '/fitness',
  scheduleFilters: '/schedule/filters',
  trainers: '/trainers',
  services: '/services',
  about: '/about',
  bookings: '/bookings',
  book: '/book',
  account: '/account',
  subscriptionPlans: '/subscription-plans',
  mySubscriptions: '/my-subscriptions',
  notifications: '/notifications',
  payLoyalty: '/pay/loyalty',
  payCheckout: '/pay/checkout',
  legalPrivacy: '/legal/privacy',
  legalCrm: '/legal/crm',
  legalRules: '/legal/rules',
  legalOrganization: '/legal/organization',
  billing: '/billing',
  myAccess: '/my-access'
} as const;
